export default __webpack_public_path__ + "static/media/character1Head.d7273644.webp";